import Header from './components/Header';
import Hero from './components/Hero';
import Carousel from './components/Carousel';
import Cards from './components/Cards';
import Media from './components/Media';
import Ranking from './components/Ranking';
import Contact from './components/Contact';
import AppSection from './components/AppSection';
import Updates from './components/Updates';
import Comments from './components/Comments';
import FAQ from './components/FAQ';
import Topics from './components/Topics';
import Features from './components/Features';
import Index from './components/Index';
import About from './components/About';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Carousel />
        <Cards />
        <Media />
        <Ranking />
        <Contact />
        <AppSection />
        <Updates />
        <Comments />
        <FAQ />
        <Topics />
        <Features />
        <Index />
        <About />
      </main>
      <Footer />
    </div>
  );
}